module.exports = __webpack_public_path__ + "static/img/20096B_1_2_R_20211028_fit.94a52c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/20096B_1_2_R_20211028_fit.png
// module id = JteB
// module chunks = 0